/**
 * Filter for video tag. Used in Lookbooks
 * @link http://stackoverflow.com/questions/15728424/html5-video-is-not-working-with-angularjs-ng-src-tag
 */
(function (itxApp) {

    'use strict';

    angular.module('itxApp.common').filter('trustUrl', ItxTrustUrlFlt);

    ItxTrustUrlFlt.$inject = ['$sce'];

    function ItxTrustUrlFlt($sce) {
        return function (recordingUrl) {
            return $sce.trustAsResourceUrl(recordingUrl);
        };
    }

    /** Public */
    itxApp.common.ItxTrustUrlFlt = ItxTrustUrlFlt;

})(window.itxApp);
